import { useContractReads } from 'wagmi'
import { useAtomValue } from 'jotai'
import { SupportedTicker } from '@/constants/token'

import { shouldUseValutContract } from '@/utils'
import { TargetChainAtom } from '@/components/common/atoms'
import { getFactoryContractAddress, getVaultContractAddress } from '@/utils/contract'

const useFee = (ticker: SupportedTicker) => {
  const targetChain = useAtomValue(TargetChainAtom)

  const resp = useContractReads({
    contracts: [
      {
        address: getVaultContractAddress(targetChain),
        abi: [
          {
            inputs: [],
            name: 'fee',
            outputs: [
              {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
              },
            ],
            stateMutability: 'view',
            type: 'function',
          },
        ],
        functionName: 'fee',
        chainId: targetChain,
      },
      {
        address: getFactoryContractAddress(targetChain),
        abi: [
          {
            inputs: [],
            name: 'fee',
            outputs: [
              {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
              },
            ],
            stateMutability: 'view',
            type: 'function',
          },
        ],
        functionName: 'fee',
        chainId: targetChain,
      },
    ],
  })

  if (shouldUseValutContract(ticker)) {
    return resp.data?.[0].status === 'success' ? resp.data?.[0].result : undefined
  } else {
    return resp.data?.[0].status === 'success' ? resp.data?.[1].result : undefined
  }
}

export default useFee
